import { Link, useLocation } from "react-router";

import { useAuth } from "@/auth/authState";
import { isItemActive, sectionForPath, type NavItem, type NavSection } from "@/fixtures/navigation";
import { cx } from "@/lib/cx";

import "./SubNav.css";

function visibleItems(section: NavSection, isAdmin: boolean): NavItem[] {
  return section.items.filter((item) => isAdmin || !item.adminOnly);
}

/**
 * De tabbalk boven de pagina (ontwerp 28-10-2026): de schermen van het
 * onderdeel waar je bent, als pillen. Wat nog gebouwd moet worden staat grijs
 * met een stip, met rechts de legenda "nog te bouwen". Je kunt er wél op
 * klikken: de placeholder zegt wat ervoor nodig is.
 *
 * Staat in de schil (AppShell), zodat elk scherm hem krijgt zonder er zelf om
 * te vragen. Onderdelen met één scherm (Dashboard, Kaart) en Vastgoed (daar is
 * het de niveaubalk in de paginakop, `PortfolioLevelBar`) tonen hem niet.
 */
export function SubNav() {
  const { pathname, search, hash } = useLocation();
  const isAdmin = (useAuth().account?.roles ?? []).includes("admin");
  const section = sectionForPath(pathname);
  if (!section || (section.subnav ?? "tabs") !== "tabs") return null;
  const items = visibleItems(section, isAdmin);
  if (items.length < 2) return null;
  const anyTodo = items.some((item) => item.built === false);
  return (
    <nav className="atl-subnav" aria-label={`Schermen in ${section.title}`}>
      <ul>
        {items.map((item) => {
          const active = isItemActive(item, pathname, hash);
          const todo = item.built === false;
          return (
            <li key={item.to}>
              <Link
                to={item.to}
                className={cx("atl-subnav__item", active && "is-active", todo && "is-todo")}
                aria-current={active ? "page" : undefined}
                title={todo ? "Nog te bouwen" : undefined}
              >
                {(active && item.activeLabel?.(new URLSearchParams(search))) || item.label}
                {todo && <i className="atl-subnav__dot" aria-label="nog te bouwen" />}
              </Link>
            </li>
          );
        })}
      </ul>
      {anyTodo && (
        <span className="atl-subnav__legend" aria-hidden>
          <i className="atl-subnav__dot" /> nog te bouwen
        </span>
      )}
    </nav>
  );
}
